<div class="webhook-failures-container">
  @if (initialLoadFailed() && loadError(); as error) {
    <tf-settings-load-error
      [title]="error"
      [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
      [details]="loadErrorDetails()"
      [dense]="true"
      [retrying]="isLoading()"
      (retry)="refreshFailures()" />
  } @else if (!hasLoadedOnce()) {
    <tf-settings-loading-placeholder [rows]="5" [columns]="columns.length" />
  } @else {
    <tf-settings-list-header
      [showSearch]="false"
      [loading]="isLoading()"
      verticalAlign="end"
      (refresh)="refreshFailures()">
    <div headerStart class="filters-row">
      <div class="filter-group">
        <div class="filter-field">
          <label for="start-date">
            {{ 'SETTINGS_WEBHOOKS.FAILURES.FILTERS.START_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="start-date"
            [ngModel]="startDate()"
            (ngModelChange)="onStartDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [maxDate]="endDate() || undefined"
            [placeholder]="'SETTINGS_WEBHOOKS.FAILURES.FILTERS.SELECT_START_DATE' | translate"
            [showClear]="true"
            styleClass="filter-input" />
        </div>

        <div class="filter-field">
          <label for="end-date">
            {{ 'SETTINGS_WEBHOOKS.FAILURES.FILTERS.END_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="end-date"
            [ngModel]="endDate()"
            (ngModelChange)="onEndDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [minDate]="startDate() || undefined"
            [placeholder]="'SETTINGS_WEBHOOKS.FAILURES.FILTERS.SELECT_END_DATE' | translate"
            [showClear]="true"
            styleClass="filter-input" />
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-field">
          <label for="event-type">
            {{ 'SETTINGS_WEBHOOKS.FAILURES.FILTERS.EVENT_TYPE' | translate }}
          </label>
          <p-select
            inputId="event-type"
            [ngModel]="eventType()"
            (ngModelChange)="onEventTypeChange($event)"
            [options]="eventTypeOptions()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'SETTINGS_WEBHOOKS.FAILURES.FILTERS.SELECT_EVENT_TYPE' | translate"
            [showClear]="true"
            styleClass="filter-input" />
        </div>

        <div class="filter-field">
          <label for="endpoint-id">
            {{ 'SETTINGS_WEBHOOKS.FAILURES.FILTERS.ENDPOINT_ID' | translate }}
          </label>
          <p-select
            inputId="endpoint-id"
            [ngModel]="endpointId()"
            (ngModelChange)="onEndpointIdChange($event)"
            [options]="endpointOptions()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'SETTINGS_WEBHOOKS.FAILURES.FILTERS.SELECT_ENDPOINT_ID' | translate"
            [showClear]="true"
            styleClass="filter-input" />
        </div>
      </div>
    </div>
    @if (hasActiveFilters()) {
      <p-button
        headerActions
        [label]="'GENERAL.CLEAR' | translate"
        severity="secondary"
        icon="pi pi-filter-slash"
        [disabled]="isLoading()"
        (onClick)="clearFilters()" />
    }
    </tf-settings-list-header>

    <tf-settings-inline-message
      [message]="actionError()"
      messageId="webhook-failures-load-error"
      (dismissed)="clearActionError()" />

    <tf-data-table
    [columns]="columns"
    [value]="failures()"
    [loading]="false"
    [paginator]="true"
    [rows]="pageSize()"
    [totalRecords]="totalRecords()"
    [lazy]="true"
    [sortField]="sortField()"
    [sortOrder]="sortOrder()"
    emptyMessageKey="SETTINGS_WEBHOOKS.FAILURES.NO_FAILURES_FOUND"
    (sorted)="onSort($event)"
    (paged)="onPageChange($event)">
    <ng-template tfColumnDef="httpStatusCode" let-failure>
      @if (failure.httpStatusCode) {
        <p-tag
          [value]="failure.httpStatusCode.toString()"
          [severity]="getHttpStatusSeverity(failure.httpStatusCode)" />
      } @else {
        <span class="text-color-secondary">-</span>
      }
    </ng-template>
    <ng-template tfColumnDef="retriesRemaining" let-failure>
      <p-tag [value]="failure.retriesRemaining.toString()" [severity]="getSeverity(failure)" />
    </ng-template>
    <ng-template tfColumnDef="firstAttemptFailedAt" let-failure>
      <span class="date-text">{{ formatDate(failure.firstAttemptFailedAt) }}</span>
    </ng-template>
    <ng-template tfColumnDef="latestRetryAttemptFailedAt" let-failure>
      <span class="date-text">{{ formatDate(failure.latestRetryAttemptFailedAt) }}</span>
    </ng-template>
    <ng-template tfColumnDef="errorMessage" let-failure>
      @if (failure.errorMessage) {
        <span class="error-message-text" [pTooltip]="failure.errorMessage" tooltipPosition="top">
          {{
            failure.errorMessage.length > 50
              ? failure.errorMessage.substring(0, 50) + '...'
              : failure.errorMessage
          }}
        </span>
      } @else {
        <span class="text-color-secondary">-</span>
      }
    </ng-template>
    </tf-data-table>
  }
</div>
